/**
 * Created by anthony on 4/16/14.
 */


navBar.classy.controller({
    name: 'NavbarController',
    inject: ['$scope', 'authServiceFactory', '$state', 'ApplicationService', 'ApplicationsSubNavbarService', 'UserSchoolModelService', '$location', 
        '$cookieStore', 'deviceDetector', 'FeedbackModalService', 'CommitteeModeModelService', 'CommitteeModeModalService', 'CSNotesModelService', 'BinFactory', 'BinService', '$anchorScroll'],
    init: function ()
    {
        this.$.versionNo = versionNo;
        this.$.CommitteeModeModelService = this.CommitteeModeModelService;
        this.$.CommitteeModeModalService = this.CommitteeModeModalService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.BinFactory = this.BinFactory;
        this.$.BinService = this.BinService;
        this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;
        this.$.UserSchoolModelService = this.UserSchoolModelService;
        this.$.deviceDetector = this.deviceDetector;
        this.$.FeedbackModalService = this.FeedbackModalService;
        this.$.ApplicationService = this.ApplicationService;
        this.$.CSNotesModelService = this.CSNotesModelService;
        this.$.notes = this.CSNotesModelService.get(this.authServiceFactory.getAuth().schoolID);
    },
    isActive: function (state)
    {
        return (this.$state.$current.toString().split('.')[1] === state);
    },
    changeSchool: function (index)
    {
        var auth = this.$cookieStore.get('auth');
        auth.schoolID = index;
        this.authServiceFactory.set(auth);
        this.$state.go(this.$state.$current, null, {reload: true});
    },
    dropdownClick: function()
    {
        this.item = this.CommitteeModeModelService.get()[0];
        
            var t = this.item.startDate.split(/[- :]/);
            var u = this.item.startTime.split(/[- :]/);
            if (t[0] !== "0000")
                var committeeDate =  new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
            var committeeTime =  new Date();
            
            var floor = new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
            floor.setHours(Number(u[0])-2);
            floor.setMinutes(u[1]);
            var ceiling = new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
            ceiling.setHours(Number(u[0])+2);
            ceiling.setMinutes(u[1]);
            console.log(floor);
            console.log(committeeTime);
            console.log(ceiling);

            if (committeeTime > floor && committeeTime < ceiling) {
                this.CommitteeModeModalService.initModal(0);
            }
            else {
                this.CommitteeModeModalService.initModal(1);
            }
    },
    binClick:function(bin)
    {
        if (this.BinFactory.bins[bin])
        {
            if (this.BinService.getBin() == bin)
            {
                var filters = ["taxFilter", "gradeFilter", "NRFilter", "SubCatsFilter", "accountsFilter"]
                for (var i = 0; i < filters.length; i++)
                {
                    var filter = filters[i];
                    for (let prop in this.BinService.filter[filter].values)
                        this.BinService.filter[filter].values[prop] = false;
                }
                this.BinService.updateFilter(filter);
                this.BinService.setFilter(filter, this.BinService.filter[filter]);
            }
            else
            {
                this.$location.hash('app0');
                this.$anchorScroll();
                this.BinService.setBin(bin);
                this.BinSummaryService.refresh();
            }
        }
        else {
            this.BinService.setBin(bin);
            this.BinSummaryService.refresh();
        }

    },
    scannerDownAlert: function() {
        alert("** Our Tax Scanning system is currently down for maintenance. ** \n\nWe expect to have it ready within 24-48 hours. In the meantime, taxes may be submitted by mailing them to FAST at:\n2207 Concord Pike #417 \nWilmington, DE 19803. \n\nWe apologize for any inconvenience that this may cause.  \n\nSincerely,\nthe FAST Team");
    }
})